import { render } from "./AspectContainer.vue?vue&type=template&id=7547b325"
import script from "./AspectContainer.vue?vue&type=script&lang=js"
export * from "./AspectContainer.vue?vue&type=script&lang=js"

import "./AspectContainer.vue?vue&type=style&index=0&id=7547b325&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__